export default __webpack_public_path__ + "static/media/mmf_logo.04d160ab.svg";